import axios from "axios";
import React, { useState } from "react";
import { GET_BASE_URL } from "../utils/Constants";
import searchIcon from "..//assets/res/search_black.svg";

const ModifyGame = () => {
  const [isForIosCheck, setIsForIosCheck] = useState(false);
  const [isForAndroidCheck, setIsForAndroidCheck] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imageName, setImageName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    author: "",
    category: "",
    size: "",
    rating: "",
    reviews: "",
    link: "",
    download: "",
  });

  const handleSearch = async () => {
    try {
      const response = await axios.get(GET_BASE_URL() + "search_game.php", {
        params: { query: searchQuery },
      });

      if (response.data && response.data.success) {
        const data = response.data.game;
        console.log(data.id); // Assuming the response has a "game" object with details
        setFormData({
          id: data.id,
          name: data.name,
          description: data.description,
          author: data.author,
          category: data.category,
          size: data.size,
          rating: data.rating,
          reviews: data.reviews,
          link: data.link,
          download: data.download,
        });
        setIsForIosCheck(data.isForIos === 1);
        setIsForAndroidCheck(data.isForAndroid === 1);
        setImageName(data.image);
        alert("Data loaded successfully");
      } else {
        alert("Game not found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Error fetching data");
    }
  };

  const handleSubmitNew = async (event) => {
    event.preventDefault();
    const sendData = {
      ...formData,
      image: imageName,
      isForIos: isForIosCheck ? 1 : 0,
      isForAndroid: isForAndroidCheck ? 1 : 0,
    };

    if (imageName.length === 0) {
      alert("Image not uploaded");
      return;
    }

    console.log(sendData);
    axios
      .post(GET_BASE_URL() + "modify_game.php", sendData)
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          alert("Success adding data");
        } else {
          alert("Error adding data");
        }
      })
      .catch((error) => {
        console.log(error.toJSON());
      });
  };

  const handleImageFile = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    setImageFile(file);
  };

  const handleImageUpload = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image_path", imageFile);

    axios
      .post(GET_BASE_URL() + "upload.php", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((result) => {
        if (result.data.length > 0) {
          alert("Image uploaded");
          setImageName(result.data);
        } else {
          alert("Error uploading image");
        }
      });
  };

  const handleImageDeletion = () => {
    console.log(imageName);
    axios
      .post(GET_BASE_URL() + "delete_image.php", { image_name: imageName })
      .then((response) => {
        setImageName("");
        console.log(response.data);
      })
      .catch((error) => console.error(error));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="mx-auto p-[32px] bg-gray-100 flex-1">
      <h1 className="pb-[8px] text-[22px] semiBold text-black">Modify Game</h1>
      <h4 className="text-[18px] medium pb-[32px] text-gray-800">Search and edit existing games in your catalog</h4>

      {/* Search Bar */}
      <div className="p-[16px] flex-1 border-[1px] border-gray-400 bg-white rounded-lg">
        <h1 className="pb-[8px] semiBold text-[20px] text-black">Search Games</h1>
        <h4 className="text-[16px] medium pb-[32px] text-gray-800">Find a game to modify or remove</h4>

        <div className="flex flex-col width-max sm:flex-row items-center   gap-4">
          <div className="flex flex-row flex-1  sm:w-2/3  width-max items-center border border-secondary rounded-lg">
            <div className="h-6 w-6  ml-4">
              <img src={searchIcon} className="h-6 w-6"></img>
            </div>
            <input
              type="text"
              placeholder="Search game by name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="p-2  "
            />
          </div>

          <button
            onClick={handleSearch}
            className="bg-black px-3 py-2 text-white medium rounded-lg hover:bg-primaryDark transition"
          >
            Search
          </button>
        </div>

      </div>

      <div className="mt-[32px] p-[16px] flex-1 border-[1px] border-gray-400 bg-white rounded-lg">

        <div className="flex flex-col width-max sm:justify-start gap-4">
          <label
            className="block text-lg font-bold sm:mr-4 text-[16px]"
            htmlFor="image_path"
          >
            Image Path
          </label>
          <div className="flex flex-col sm:flex-row items-center gap-2 w-full ">
            <input
              type="file"
              name="image_path"
              id="image_path"
              onChange={handleImageFile}
              className="w-full p-2 border border-secondary rounded-lg flex-1"
              accept="image/*"
            />

            {imageName.length > 0 ? (
              <div className="rounded-full bg-green-500 h-8 w-8"></div>
            ) : (
              <button
                onClick={handleImageUpload}
                className="bg-black px-3 py-2 text-white medium rounded-lg hover:bg-black transition"
              >
                Upload
              </button>
            )}

            <button
              onClick={handleImageDeletion}
              className="bg-black medium px-3 py-2 text-white rounded-lg hover:bg-black transition"
            >
              Remove Image
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmitNew} className="space-y-4 mt-4">
          {[
            {
              label: "Name",
              name: "name",
              type: "text",
              placeholder: "Enter name",
            },
            {
              label: "Description",
              name: "description",
              type: "textarea",
              placeholder: "Enter description",
            },
            {
              label: "Author",
              name: "author",
              type: "text",
              placeholder: "Enter author",
            },
            {
              label: "Category",
              name: "category",
              type: "text",
              placeholder: "Mod / Game / App",
            },
            { label: "Size", name: "size", type: "text", placeholder: "300MB" },
            { label: "Rate", name: "rating", type: "number", placeholder: "4.2" },
            {
              label: "Reviews",
              name: "reviews",
              type: "text",
              placeholder: "20k+",
            },
            {
              label: "Redirect Link",
              name: "link",
              type: "text",
              placeholder: "Enter redirect link",
            },
            {
              label: "Download",
              name: "download",
              type: "text",
              placeholder: "200k+",
            },
          ].map((field, index) => (
            <div
              key={index}
              className="flex-col sm:flex-row sm:justify-start lg:justify-between"
            >
              <label className="block text-[16px] font-bold w-full sm:w-1/4">
                {field.label}
              </label>
              {field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  className="w-full p-2 bg-gray-200 rounded-lg placeholder-gray-800"
                />
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  step="any"
                  onChange={handleInputChange}
                  className="w-full  p-2  bg-gray-200 rounded-lg placeholder-gray-800"
                  required={field.label !== "Size"}
                />
              )}
            </div>
          ))}

          <div className="flex-row sm:flex-row items-center gap-4 sm:justify-start">
            <label className="block text-lg font-bold text-[16px] pb-[8px]">Operating System</label>
            <div className="flex items-center gap-4 sm:gap-8 medium">
              <div className="flex items-center gap-2">
                <span>iOS</span>
                <input
                  type="checkbox"
                  name="isForIos"
                  checked={isForIosCheck}
                  onChange={() => setIsForIosCheck(!isForIosCheck)}
                  className="w-6 h-6"
                />
              </div>
              <div className="flex items-center gap-2">
                <span>Android</span>
                <input
                  type="checkbox"
                  name="isForAndroid"
                  checked={isForAndroidCheck}
                  onChange={() => setIsForAndroidCheck(!isForAndroidCheck)}
                  className="w-6 h-6"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center sm:justify-start mt-4">
            <button
              type="submit"
              className="w-full justify-center medium px-4 py-2 bg-black text-white rounded-lg hover:bg-black transition"
            >
              Submit
            </button>
          </div>
        </form>
      </div>


    </div>
  );
};

export default ModifyGame;
